const PIXEL_ID = '26207723622223908'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  // Load fbq script
  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  f.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackPageView() {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  const f = window as any
  if (f.fbq) {
    f.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Anti-Inflamatorio 72h',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
